import React from 'react';
import VariableDonutChart from '@di-shared/features/common/VariableDonutChart';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

interface SafeDrivingSummaryGraphEuProps {
  score: number;
  scoreDiff: number;
}

function SafeDrivingSummaryGraphEu({score, scoreDiff}: SafeDrivingSummaryGraphEuProps) {
  const {t} = useInferableTranslation();
  const ratio = getGraphRatio(score);
  const color = getGraphColor(score);
  return (
    <div className="driving_score_graph_area">
      <VariableDonutChart
        color={color}
        ratio={ratio}
        width={190}
        strokeWidth={10}
        angle={45}
      />
      <div className="driving_mileage_graph_info">
        <span className="driving_mileage_graph_score">
          <span className="score_value">{score}</span>
        </span>
        <span className="driving_mileage_graph_compare">
          <span className="compare_value type_plus">
            {scoreDiff >= 0 ? '+' : ''}
            {scoreDiff}
          </span>
          <span className="compare_text">{t('ctn_home_dss_points')}</span>
        </span>
      </div>
    </div>
  );
}

export default SafeDrivingSummaryGraphEu;

function getGraphRatio(score: number) {
  if (score > 100) {
    return 1;
  }
  if (score > 65) {
    return ((score - 65) / 35) * (2 / 3) + 1 / 3;
  }
  return 1 / 3;
}

function getGraphColor(score: number) {
  if (score < 65) {
    return 'var(--surface-container-low)';
  }
  if (score < 75) {
    return 'var(--quaternary-low)';
  }
  if (score < 89) {
    return 'var(--tertiary)';
  }
  return 'var(--graph-gauge-active)';
}
